<mat-form-field floatLabel="always" class="header-location-picker">
  <mat-icon [inline]="false" matPrefix>location_on</mat-icon>
  <input
    type="text"
    placeholder="Pick a location"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    (input)="shouldFilter$.next(true)"
    (focus)="$event.target.select()"
    #input
    />

    <mat-icon [inline]="false" matSuffix>keyboard_arrow_down</mat-icon>
    <mat-autocomplete
      #auto="matAutocomplete"
      [autoActiveFirstOption]="true"
      (optionSelected)="selectLocation($event.option); input.blur()"
      [displayWith]="displayOption"
      >
      @for (option of filteredLocations$ | async; track option) {
        <mat-option [value]="option">
          <div class="customer">{{ option.customer }}</div>
          <div class="location">{{ option.name }}</div>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
